export const labels = {
  verify: 'Verify',
  resendCode: 'Resend Code',
  verifyOTP: 'Verification Required',
  update: 'Update',
  updateEmailAddress: 'Update Email Address',
  enterVerificationCode: 'Enter Verification Code sent to',
  otpNotReceived:
    'Didn’t receive your Verification Code? You can request a new one in:',
  emailChangedSuccessfully:
    'Your email address has been updated successfully. You can now log in with your new email. '
};
